import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApiResponseDocument, OpalApi } from '../../schema'

type ReadCustomFieldColorsV3 = OpalApi<'ReadCustomFieldColorsV3', 200>

export const readCustomFieldColors: ReadCustomFieldColorsV3 = async ({
  params,
}: Parameters<ReadCustomFieldColorsV3>[0] = {}) => {
  const url = new URL('/loupe/v3/custom_field_colors', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get<OpalApiResponseDocument<'ReadCustomFieldColorsV3', 200>>(
      url.toString()
    )
    .then((res) => res.data)
}
